import { graphqlQuery } from '../../apis/graphqlClient';
let codeMasterCache = null;
const CODE_MASTER_QUERY = `
  query codeMasters($codeTypes: [String!]!) {
    codeMasters(codeTypes: $codeTypes) {
      itemName
      items {
        codeValue
        codeDisplay
        sortOrder
      }
    }
  }
`;
const ALL_CODE_TYPES = [
    'status_site_survey',
    'handling_type',
    'prefecture',
    'contract_type',
    'ownership_type',
    'building_type',
    'license_plan',
    'submission_method',
];
export const fetchCodeMaster = async (codeTypes = ALL_CODE_TYPES) => {
    const data = await graphqlQuery(CODE_MASTER_QUERY, { codeTypes });
    const result = {};
    data.codeMasters.forEach(group => {
        result[group.itemName] = group.items;
    });
    return result;
};
export const setCodeMaster = (data) => {
    codeMasterCache = data;
};
export const getCodeMaster = () => {
    return codeMasterCache || {};
};
export const getCodeMasterItems = (itemNameValue) => {
    if (!codeMasterCache)
        return [];
    return codeMasterCache[itemNameValue] || [];
};
export const isCodeMasterLoaded = () => {
    return codeMasterCache !== null;
};
export const populateSelect = (selectId, itemNameValue, placeholder) => {
    const select = document.getElementById(selectId);
    if (!select)
        return;
    const currentValue = select.value;
    select.innerHTML = '';
    if (placeholder) {
        const opt = document.createElement('option');
        opt.value = '';
        opt.textContent = placeholder;
        select.appendChild(opt);
    }
    const items = getCodeMasterItems(itemNameValue);
    items.forEach(item => {
        const opt = document.createElement('option');
        opt.value = item.codeValue;
        opt.textContent = item.codeDisplay;
        select.appendChild(opt);
    });
    if (currentValue) {
        select.value = currentValue;
    }
};
